import { render, staticRenderFns } from "./getwayPakgConfig.vue?vue&type=template&id=0016ea9e&"
import script from "./getwayPakgConfig.vue?vue&type=script&lang=js&"
export * from "./getwayPakgConfig.vue?vue&type=script&lang=js&"
import style0 from "./getwayPakgConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0016ea9e')) {
      api.createRecord('0016ea9e', component.options)
    } else {
      api.reload('0016ea9e', component.options)
    }
    module.hot.accept("./getwayPakgConfig.vue?vue&type=template&id=0016ea9e&", function () {
      api.rerender('0016ea9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pakgConfig/getwayPakgConfig.vue"
export default component.exports